import React from "react";
import ReactDOM from "react-dom";
import DualAxes from "@ant-design/plots/es/components/dual-axes";

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];

function randomIntFromInterval(min, max) {
  // min and max included
  return Math.floor(Math.random() * (max - min + 1) + min);
}

const DemoDualAxes = () => {
  const data = months.reduce((p, c) => {
    const val = randomIntFromInterval(80, 100);
    const val2 = randomIntFromInterval(80, 100);
    return [
      ...p,
      {
        month: c,
        value: val,
        category: "Fill rate"
      },
      {
        month: c,
        value: val2,
        category: "Weighted Fill rate"
      }
    ];
  }, []);

  const gmvData = months.map((m, index) => ({
    month: m,
    value2: randomIntFromInterval(1000, 1200),
    category: "Potential loss"
  }));

  const config = {
    data: [data, gmvData],
    xField: "month",
    yField: ["value", "value2"],
    geometryOptions: [
      {
        geometry: "line",
        seriesField: "category",
        smooth: true,
        point: {},
        lineStyle: {
          lineWidth: 1
        }
      },
      {
        geometry: "line",
        seriesField: "category",
        smooth: true,
        lineStyle: {
          lineWidth: 2,
          lineDash: [5, 5]
        },
        point: {}
      }
    ],
    yAxis: {
      value: {
        min: Math.min(...data.map((x) => x.value)) / 5,
        max: Math.max(...data.map((x) => x.value)) * 1.1,
        label: {
          formatter: (v) => `${v} %`
        }
      },
      value2: {
        min: Math.min(...gmvData.map((x) => x.value2)) / 1.3,
        max: Math.max(...gmvData.map((x) => x.value2)) * 1.3
      }
    },
    tooltip: {
      // Check category and set value accordingly
      // formatter: (datum) => {
      //   console.log(datum);
      //   return { name: datum.x, value: datum.y + "%" };
      // }
    }
  };
  return <DualAxes {...config} />;
};

ReactDOM.render(<DemoDualAxes />, document.getElementById("container"));



// WEBPACK FOOTER //
// ./src/index.js